<div class="icon-list-container position-relative">
  <div class="icon-list position-fixed top-0 end-0 p-m">
    @if(profileService.profile() !== null) {
      @if (capabilities.capabilities().developer) {
        <app-tooltip [text]="('EDIT' | translate)" [opensOn]="'Auto'" [position]="'BottomCenter'">
          <app-icon-badge (click)="switchEditing()" [style]="'barTop'" [icon]="'edit'" [screenReaderText]="'EDIT' | translate"></app-icon-badge>
        </app-tooltip>
      }

      @if (isHomeRoute()) {
        <app-tooltip [text]="('DASHBOARDSEARCHWIKI' | translate)" [opensOn]="'Auto'" [position]="'BottomCenter'">
          <app-icon-badge (click)="routerService.navigateTo('/knowledgebase')" [style]="'barTop'" [icon]="'search'" [screenReaderText]="'DASHBOARDSEARCHWIKI' | translate"></app-icon-badge>
        </app-tooltip>
      }
      <app-tooltip [text]="('SRNEWALERTS' | translate)" [opensOn]="'Auto'" [position]="'BottomCenter'">
        <app-icon-badge (click)="setTab('notifications')" [style]="'barTop'" [icon]="'notifications'" [alert]="hasNonChatBadgeAlert()" [screenReaderText]="'SRNEWALERTS' | translate"></app-icon-badge>
      </app-tooltip>
      @if (capabilities.capabilities().chat !== null) {
        <app-tooltip [text]="('SRNEWMASSAGES' | translate)" [opensOn]="'Auto'" [position]="'BottomCenter'">
          <app-icon-badge (click)="setTab('chat')" [style]="'barTop'" [icon]="'chat_bubble'" [alert]="iconsBadges.get('chat') ?? false" [screenReaderText]="'SRNEWMASSAGES' | translate"></app-icon-badge>
        </app-tooltip>
      }

      <div class="dropdown d-inline p-1">
        <button type="button" class="btn btn-link p-0 text-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" data-bs-display="static">
          <app-avatar [image]="profileService.profile()?.user?.avatar?.path || ''" [name]="profileService.profile()?.user?.first_name + ' ' + profileService.profile()?.user?.last_name" [type]="'small'"></app-avatar>
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
          <li><app-link (click)="profileLanguageDialog = true;" [title]="('LANGUAGE' | translate)" [style]="'dropdown'">{{ ('LANGUAGE' | translate) }}</app-link></li>
          <li>
            <app-link (click)="toggleAutomaticTranslation()" [title]="('AUTOTRANSLATEONOFF' | translate)" [style]="'dropdown'">
              <span class="e-icons e-translate fs-default" [ngClass]="{'text-light': !!profileService.profile()?.user?.auto_translation, 'text-muted': !profileService.profile()?.user?.auto_translation }"></span>
              {{ ('AUTOTRANSLATEONOFF' | translate) }}
            </app-link>
          </li>
          <li><hr class="dropdown-divider"></li>
          <li><app-link (click)="routerService.navigateTo('/profile')" [title]="('PROFILE' | translate)" [style]="'dropdown'">{{ ('PROFILE' | translate) }}</app-link></li>
          <li><app-link (click)="profilePushDialog = true;" [title]="('NOTIFICATIONSETTINGS' | translate)" [style]="'dropdown'">{{ ('NOTIFICATIONSETTINGS' | translate) }}</app-link></li>
          <li><app-link (click)="appDownloadDialog = true;" [title]="('APPDOWNLOAD' | translate)" [style]="'dropdown'">{{ ('APPDOWNLOAD' | translate) }}</app-link></li>
          @if (shouldShowIconBarToggle()) {
            <li><app-link (click)="barIconService.toggleIconBar()" [title]="('BARICONSVISIBILITY' | translate)" [style]="'dropdown'">{{ ('BARICONSVISIBILITY' | translate) }}</app-link></li>
          }
          <!-- TODO: Once the disable dashboard settings is implemented add bellow an option for users to customize their icons (icon side bar) if that setting was enabled from the settings by admins, because due to the fact that they have no access to the dashboard anymore, they also have no access to the icon which popup up the icon customization dialog for them-->
          <li><hr class="dropdown-divider"></li>
          <li><app-link (click)="signOut()" [title]="('SIGNOUT' | translate)" [style]="'dropdown'">{{ ('SIGNOUT' | translate) }}</app-link></li>
        </ul>
      </div>
    }

    @if (tab) {
      <div class="notification-window shadow-lg p-3 d-flex flex-column">
        @if (tab === 'notifications') {
          <div class="d-flex justify-content-end align-items-center mb-2">
            <app-form-button [style]="'btn'" (click)="closeTab()" [cssClass]="'btn-close'"></app-form-button>
          </div>
        }
        @if (tab === 'chat') {
          <div class="d-flex justify-content-between align-items-center mb-2">
            <app-headline [title]="('CHATNOTIFICATIONS' | translate)" [type]="'h6'"></app-headline>
            <div class="d-flex align-items-center">
              <div class="dropdown me-2">
                <div data-bs-toggle="dropdown" aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                  <app-icon-badge [style]="'notification'" [icon]="'more_vert'"></app-icon-badge>
                </div>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li><app-link (click)="setRead('chat')" [title]="('BELLSETALLREAD' | translate)" [style]="'dropdown'">{{ ('BELLSETALLREAD' | translate) }}</app-link></li>
                </ul>
              </div>
              <app-form-button [style]="'btn'" (click)="closeTab()" [cssClass]="'btn-close'"></app-form-button>
            </div>
          </div>
        }
        @if (tab === 'notifications') {
          <div class="d-flex">
            <app-form-button [text]="'NEW' | translate" [cssClass]="status === 'unread' ? 'e-primary w-100 mx-1' : 'e-outline w-100 mx-1'" (click)="setStatus('unread')"></app-form-button>
            <app-form-button [text]="'READ' | translate" [cssClass]="status === 'read' ? 'e-primary w-100 mx-1' : 'e-outline w-100 mx-1'" (click)="setStatus('read')"></app-form-button>
          </div>
        }
        @if (tab === 'notifications') {
          <div class="d-flex justify-content-between align-items-center mt-3 pb-1">
            <app-headline [type]="'h6'" [title]="('NOTIFICATIONS' | translate)"></app-headline>
            @if (tab === 'notifications') { 
              <div class="dropdown">
                <div data-bs-toggle="dropdown" aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                  <app-icon-badge [style]="'notification'" [icon]="'more_vert'"></app-icon-badge>
                </div>
                <ul class="dropdown-menu dropdown-menu-end">
                  @if (status === 'read') {
                    <li><app-link (click)="setUnread('notifications')" [title]="('BELLSETALLUNREAD' | translate)" [style]="'dropdown'">{{ ('BELLSETALLUNREAD' | translate) }}</app-link></li>
                  } @else {
                    <li><app-link (click)="setRead('notifications')" [title]="('BELLSETALLREAD' | translate)" [style]="'dropdown'">{{ ('BELLSETALLREAD' | translate) }}</app-link></li>
                  }
                </ul>
              </div>
            }
          </div>
        }
        @if (profileService.profile()) {
          @if (
            !profileService.profile()!.notifications.send_from_chat ||
            !profileService.profile()!.notifications.send_to_web ||
            firebaseService.notificationState() !== 'granted'
          ) {
            <app-warning [message]="'WARNINGNOTIFICATIONS' | translate" [linkText]="'WARNINGNOTIFICATIONSLINK' | translate" (click)="profilePushDialog = true;"></app-warning>
            }
          }
        @if (tab === 'notifications') {
          <div class="d-flex justify-content-end mb-3" >
            <div class="col-md-6">
              <app-form-dropdown [fG]="filterForm" [fCN]="'module'" [dataSource]="activeChannels()" [icon]="'filter_list'" [cssClass]="'small-filter-dropdown'" ></app-form-dropdown>
            </div>
          </div>
        }
        <div class="custom-scrollbar" (scrollend)="layoutService.setScrollToEnd($event, 'bar-top')">
          @for (item of notifications(); track $index) {
            @if (shouldShowNotificationDateDivider($index)) {
              <app-divider-date [date]="formatDividerDate(item)"></app-divider-date>
            }
            <app-notification 
            [notification]="item"
            [variant]="'compact'"
            (asRead)="markNotificationRead($event)"
            (asUnread)="markNotificationUnread($event)"
              >
            </app-notification>
          } @empty {
            @if (shouldShowNoNotificationsMessage()) {
              <div class="p-2 text-muted text-center">
                {{ 'NONOTIFICATIONSTODISPLAY' | translate }}
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
</div>

@if (!isHomeRoute()) {
  <div class="home-icon-container position-relative">
    <div class="home-icon position-fixed top-0 start-0 p-2">
      <app-tooltip [text]="('HOME' | translate)" [opensOn]="'Auto'" [position]="'RightCenter'">
        <app-form-button [style]="'btn'" [icon]="'apps'" [cssClass]="'btn btn-link p-m text-muted position-relative'" [iconClass]="'fs-3'" (click)="routerService.navigateTo('/home')"></app-form-button>
      </app-tooltip>
    </div>
  </div>
}

@if (profileLanguageDialog) {
  <app-dialog-profile-language [(visible)]="profileLanguageDialog"></app-dialog-profile-language>
}
@if (profilePushDialog) {
  <app-dialog-profile-push [(visible)]="profilePushDialog"></app-dialog-profile-push>
}
<app-app-download-dialog [(visible)]="appDownloadDialog"></app-app-download-dialog>
